import type { ServiceRow } from '@/api/services';

/**
 * Which detail tabs a service shows, by `service_template` + status. Ported 1-1
 * from the legacy `useServiceTabs` gating (Detail/tab.tsx). The generic tabs
 * (Information / Prices / Notifications / Receipts / SLA) always show; the
 * advanced tabs are template/status-gated.
 */

/** Statement (đối soát) + Configuration-editable set. */
const STATEMENT_TEMPLATES = [
  'SwiftFederation.CDN',
  'SwiftFederation.Recording',
  'SwiftFederation.Transcoding',
  'SwiftFederation.StorageLFD',
  'SwiftFederation.StorageOSS',
  'SwiftFederation.Transmuxing',
  'Mlytics.Vnis',
  'Cloud.VCloud',
];

/** Alerts + Monitoring set (statementable minus VCloud, per legacy). */
const USAGE_TEMPLATES = STATEMENT_TEMPLATES.filter((t) => t !== 'Cloud.VCloud');

/** Templates whose provisioning config is NOT editable via the config tab. */
const NO_CONFIG_EDIT = ['SSL.SSL', 'Domain.VNNIC', 'Domain.TLDs', 'Device.Liquidation'];

export function showStatementTab(s: Pick<ServiceRow, 'service_template' | 'is_poc'>): boolean {
  return !s.is_poc && STATEMENT_TEMPLATES.includes(s.service_template);
}

export function showAlertsTab(s: Pick<ServiceRow, 'service_template'>): boolean {
  return USAGE_TEMPLATES.includes(s.service_template);
}

export function showMonitoringTab(s: Pick<ServiceRow, 'service_template' | 'service_status'>): boolean {
  return (
    USAGE_TEMPLATES.includes(s.service_template) &&
    (s.service_status === 'active' || s.service_status === 'trialing')
  );
}

/** Configuration tab is hidden for terminal states + non-config templates. */
export function showConfigTab(s: Pick<ServiceRow, 'service_template' | 'service_status'>): boolean {
  if (NO_CONFIG_EDIT.includes(s.service_template)) return false;
  return s.service_status !== 'rejected' && s.service_status !== 'pending-terminated';
}

/** Config values are editable only while the service is still waiting-confirm. */
export function isConfigEditable(s: Pick<ServiceRow, 'service_template' | 'service_status'>): boolean {
  return s.service_status === 'waiting-confirm' && !NO_CONFIG_EDIT.includes(s.service_template);
}
